import { render } from "./Binghai.vue?vue&type=template&id=087b4883&scoped=true"
import script from "./Binghai.vue?vue&type=script&lang=js"
export * from "./Binghai.vue?vue&type=script&lang=js"

import "./Binghai.vue?vue&type=style&index=0&id=087b4883&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087b4883"]])

export default __exports__